import './styles.scss';
import { ReactComponent as CompletedIcon } from '../../../assets/icons/status/completed.svg';
import { ReactComponent as PendingIcon } from '../../../assets/icons/status/pending.svg';
import { ReactComponent as RejectedIcon } from '../../../assets/icons/status/rejected.svg';
import { ReactComponent as ReviewIcon } from '../../../assets/icons/status/review.svg';
import { ReactComponent as CancelledIcon } from '../../../assets/icons/status/cancelled.svg';
import Tooltip from '@mui/material/Tooltip';

import l from '../../../lang';

interface StatusIconProps {
  status: string;
  labelKeyPrefix?: string;
}

const StatusIcon = ({ status, labelKeyPrefix = 'refunds.status' }: StatusIconProps) => {
  const normalized = (status ?? '').toLowerCase();
  const label = l(`${labelKeyPrefix}.${status}`);

  const renderIcon = () => {
    if (normalized === 'completed') {
      return <CompletedIcon className="status-icon" aria-hidden />;
    }
    if (['pending', 'created', 'on_hold','processing'].includes(normalized)) {
      return <PendingIcon className="status-icon" aria-hidden />;
    }
    if (['rejected', 'declined', 'failed'].includes(normalized)) {
      return <RejectedIcon className="status-icon" aria-hidden />;
    }
    if (normalized === 'review') {
      return <ReviewIcon className="status-icon" aria-hidden />;
    }
    if (['cancelled', 'expired'].includes(normalized)) {
      return <CancelledIcon className="status-icon" aria-hidden />;
    }
    return null;
  };

  const icon = renderIcon();

  if (!icon) {
    return null;
  }

  return (
    <Tooltip title={label} arrow describeChild>
      <span className="status-icon__wrap" tabIndex={0} aria-label={label}>
        {icon}
      </span>
    </Tooltip>
  );
};

export default StatusIcon;
